const sessionCount = (localStorage.session ? parseInt(localStorage.session, 36) + 1 : 0).toString(36);
localStorage.session = sessionCount;
setInterval(() => {
	if (localStorage.session !== sessionCount) {
		window.location.href = "esr";
	}
}, 1e3);
